// extracted by mini-css-extract-plugin
export default {"root":"styles_root__cIa9c","uploadArea":"styles_uploadArea__uiDtu","uploaded":"styles_uploaded__xVP94","placeholder":"styles_placeholder__LIxXz"};